module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALNJREFUeNpiYBgFwx0wkqtRSlzaHo/0h2cvn17Ep5+FAkcfwCP3AIgVaWUxCCyAYgwfE9LINBTj+D++oAbG8WhQjwb1aFDTJ6hZqByCF4A+/UiMQkrjOAFaZsNwAbEaqR3UF+hlMSgRHSRH44BlJyYyspE+MWK08PEEoEXxSJbOB1IB9ApqWIIqgKZsusRxAVIBIQBNyRPoUmRC4/QAtG3lQGyhQRUAshyI+Ucb6oMeAAQYAIYiOyWqi59+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/9.png
// module id = 764
// module chunks = 0